import { useMonitor } from '../use-monitor';

export function useMonitorDiscardIssueFormSubmit() {
  return useMonitor('discard-issue-form-submit');
}
